module.exports = __webpack_public_path__ + "img/translator__ch-ru.d8ae654.svg";